import {styled, Box} from '@mui/material'
import SparkleIcon from '@mui/icons-material/AutoAwesome'

export const StyledChatbotCTA = styled(Box)(({theme}) => ({
  backgroundColor: theme.palette.secondary.light,
  border: `1px solid ${theme.palette.secondary.main}`,
  borderRadius: '8px',
  padding: theme.spacing(2),
  margin: `${theme.spacing(2)} 0`,
  color: theme.palette.secondary.dark,
  textAlign: 'center'
}))

export const StyledChatbotCTAIcon = styled(Box)(({theme}) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: theme.spacing(1),
  width: '60px',
  height: '60px',
  borderRadius: '50%',
  backgroundColor: theme.palette.primary.contrastText,
  margin: '0 auto 8px auto',
  '& svg': {
    fill: theme.palette.secondary.dark
  }
}))

export const StyledChatbotCTATitle = styled(Box)(({theme}) => ({
  marginBottom: theme.spacing(1),
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.body1.fontSize
}))

export const StyledChatbotCTADescription = styled(Box)(({theme}) => ({
  fontSize: theme.typography.body2.fontSize,
  marginBottom: theme.spacing(1.5),
  color: theme.palette.hpAccentBlack
}))

export const StyledChatbotCTAButton = styled(Box)(({theme}) => ({
  display: 'inline-flex',
  alignItems: 'center',
  backgroundColor: theme.palette.secondary.dark,
  color: theme.palette.hpWhite,
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  borderRadius: '4px',
  fontSize: theme.typography.button.fontSize,
  fontWeight: theme.typography.fontWeightBold,
  cursor: 'pointer'
}))

export const StyledSparkleIcon = styled(SparkleIcon)(({theme}) => ({
  marginRight: theme.spacing(1),
  fontSize: theme.typography.titleMedium.fontSize
}))
